<div data-at-status class="icon-status flex flex-row gap-[5px] justify-start items-center">
  <mat-icon
    *ngIf="isColdSystem"
    [matTooltip]="getTooltip()"
    class="cold-system-mode flex flex-row justify-center items-stretch flex-[20px] max-w-[20px]"
    >cancel</mat-icon
  >
  <ng-container
    *ngIf="
      installationsStore.selectAggregatedStatus(gateway?.serial) | async as currentAggregatedStatus
    "
  >
    <mat-icon
      *ngIf="currentAggregatedStatus === aggregatedStatus.Error"
      [matTooltip]="getTooltip()"
      class="error-mode flex flex-row justify-center items-stretch flex-[20px] max-w-[20px]"
      >error</mat-icon
    >
    <mat-icon
      *ngIf="currentAggregatedStatus === aggregatedStatus.Offline"
      [matTooltip]="getTooltip()"
      class="offline-mode flex flex-row justify-center items-stretch flex-[20px] max-w-[20px]"
      >wifi_off</mat-icon
    >
    <mat-icon
      *ngIf="currentAggregatedStatus === aggregatedStatus.Maintenance"
      [matTooltip]="getTooltip()"
      class="maintenance-mode flex flex-row justify-center items-stretch flex-[20px] max-w-[20px]"
      >build</mat-icon
    >
    <mat-icon
      *ngIf="currentAggregatedStatus === aggregatedStatus.RemoteDiagnosticSession"
      [matTooltip]="getTooltip()"
      class="diagnostic-mode flex flex-row justify-center items-stretch flex-[20px] max-w-[20px]"
      >timeline</mat-icon
    >
    <mat-icon
      *ngIf="currentAggregatedStatus === aggregatedStatus.NBIoT"
      [matTooltip]="getTooltip()"
      class="nbiot-mode flex flex-row justify-center items-stretch flex-[20px] max-w-[20px]"
      >check_circle</mat-icon
    >
  </ng-container>
</div>
